<template>
  <van-popup v-model="showPicker" round :position="position">
    <van-search
      v-model="skjsxm"
      show-action
      placeholder="请输入搜索编号或姓名、学院关键字"
      @search="onClickButton"
    > <template #action>
      <div @click="onClickButton">查询</div>
    </template></van-search>
    <van-picker
      :title="title"
      show-toolbar
      :columns="columns"
      :loading="loading"
      @confirm="onConfirm"
      @cancel="onCancel"
    />
  </van-popup>
</template>

<script>
  export default {
    name: "mobile-skjs",
    props: {
      //标题
      title: {
        type: String,
        default: ''
      },
      //弹出方向
      position: {
        type: String,
        default: 'bottom'
      },
      //类型
      type: {
        type: String,
        default: ''
      },
      callbak: {
        type: Function,
        default: null,
      }

    },
    data() {
      return {
        showPicker:false,
        value:'',
        text:'',
        columns:[],
        loading:true,
        skjsxm:"",
        index:0,
        dm:null,
        goods:[],
        sklx:[{value:'2',text:'助理'},{value:'1',text:'主讲'}]

      }
    },
    created() {
    },
    methods: {
      show(show,dm,method){
        this.showPicker = show;
        this.dm = dm;
        this.getlist();
      },
      getlist(){
        let that = this;
        let datas = {
          type:that.type,
          q:that.skjsxm
        };
        that.columns = [];
        this.$ajax.post('/appapi/teachertksq/getskjs',datas).then(function (rep) {
          if (rep.code == 200) {
             let columnsvalue=rep.skjslist;
             let skjslist = [];
            columnsvalue.map(item=>{
              if(!that.dm.includes(item.value)){
                 skjslist.push(item)
              }
            })
            that.columns.push({values:skjslist,defaultIndex: 1},{values:that.sklx,defaultIndex:2}) ;
            that.goods = rep.skjslist;
            that.loading = false;
          }
        });
      },
      onConfirm(columns, index) {
        this.value = columns[0].value+"-"+columns[1].value;
        this.text = columns[0].text+"["+columns[1].text+"]";
        this.callbak(this.value,this.text,columns[0].value,columns[0].text,columns[1].value);
        this.showPicker = false;
      },
      onCancel() {
        this.showPicker = false;
      },
      onClickButton()
      {
        this.loading = true;
        this.getlist();
      },
      onSearch(val)
      {
        this.loading = true;

        let columnsvalue=[];
        this.columns = [];
        this.goods.map(item=>{
          if(item.text.includes(this.skjsxm) || item.teabh.includes(this.skjsxm)|| item.yxmc.includes(this.skjsxm)){
            columnsvalue.push(item)
          }
        })
        this.columns.push({values:columnsvalue,defaultIndex: 1},{values:this.sklx,defaultIndex:2}) ;
        this.loading = false;
      },
    }
  }
</script>

<style lang="scss" >
  //picker选择器选中值设置高亮
  .van-picker-column__item {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    padding: 0 4px;
    color: #000;

    &.van-picker-column__item--selected {
      font-family: raleway, arial, sans-serif;
      font-weight: 700;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/mobile-skjs/index.vue